var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn--big btn--tertiary",on:{"click":function($event){return _vm.ConfirmAndRevoke()}}},[_vm._v(_vm._s(_vm.trans('users.label.revoke_agreements')))])
}
var staticRenderFns = []

export { render, staticRenderFns }